// extracted by mini-css-extract-plugin
export default {"strip":"_2X2hH","root":"_58z+v","icon":"LT2j9","title":"qggk8","bold":"O2aL8"};